import { BehaviorSubject } from 'rxjs';

export class NeqTreeNode {
  public identifier: string;

  childrenChange = new BehaviorSubject<NeqTreeNode[]>([]);

  get children(): NeqTreeNode[] {
    return this.childrenChange.value;
  }

  constructor(
    public label: string,
    public type: string,
    public code: string,
    public hasChildren = false,
    public isLoading = false,
    public isLoaded = false) {

    this.identifier = NeqTreeNode.getNodeIdentifier(this.type, this.code);
  }

  static getNodeIdentifier(type: string, code: string): string {
    return type + '-' + code;
  }
}
